import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { WifiOff, Refresh } from '@mui/icons-material';

interface NetworkErrorProps {
  onRetry?: () => void;
  message?: string;
}

const NetworkError: React.FC<NetworkErrorProps> = ({ 
  onRetry, 
  message = "Unable to connect to the server. Please check your internet connection and try again." 
}) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        minWidth: '100vw',
        bgcolor: '#F5F6FA',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          borderRadius: 3,
          textAlign: 'center',
          maxWidth: 450,
          boxShadow: '0 8px 32px rgba(24,26,42,0.12)',
        }}
      >
        <Box
          sx={{
            width: 100,
            height: 100,
            borderRadius: '50%',
            bgcolor: '#FEE2E2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: 3,
          }}
        >
          <WifiOff sx={{ fontSize: 50, color: '#EF4444' }} />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: '#181A2A',
            mb: 1.5,
          }}
        >
          Connection Lost
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: '#6B7280',
            mb: 3,
            lineHeight: 1.6,
          }}
        >
          {message}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Button
            variant="contained"
            startIcon={<Refresh />}
            onClick={handleRetry}
            sx={{
              py: 1.5,
              px: 4,
              bgcolor: '#3D52A0',
              '&:hover': {
                bgcolor: '#2b396e',
              },
              fontWeight: 600,
              borderRadius: 2,
              textTransform: 'none',
              fontSize: 15,
            }}
          >
            Try Again
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default NetworkError;
